import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {SearchVendorDto} from "../../auto-generated-server-dtos/adjuster/configuration/search-vendor-dto";

@Injectable({
  providedIn: 'root'
})
export class SearchVendorService {

  constructor(private httpClient: HttpClient) { }

  searchVendor(search: string) {
    return this.httpClient.get<SearchVendorDto[]>(`${environment.apiServer}/Adjuster/Configuration/SearchVendor?`, {params: {search}});
  }
}
